import React from 'react';
import PropTypes from 'prop-types';
import FormInputRadio from './FormInputRadio';
import FormInputText from './FormInputText';
import FormInputCheckbox from './FormInputCheckbox';
import { formSchemaPropType } from '../../../formSchema';

export default class FormField extends React.Component {
  renderDescription = () => {
    const { fieldData } = this.props;

    return (
      <label>
        {fieldData.desc}
      </label>
    );
  };

  render() {
    const {
      fieldData,
      fieldInput,
      userInputHandler,
      isValid,
      validationMessage,
      selectedDataQuery,
    } = this.props;
    let fieldName  = fieldData.name;
    let sDQ = JSON.parse(selectedDataQuery);
    let localFieldData = fieldData;
    const active = sDQ[fieldName] ? sDQ[fieldName] : 0;
    if ( parseInt(active) === 0) {
      delete localFieldData.req;
    }
    if (fieldData.field_type !== 'checkbox') {
      const classNames = (active === '1') ? 'input-field' : 'input-field hidden-field';

      return (
        <div className={classNames}>
          {fieldData.desc_pos === '1' && this.renderDescription()}
          {fieldData.repeat && (
            <FormInputRadio
              fieldData={localFieldData}
              fieldInput={fieldInput}
              userInputHandler={userInputHandler}
            />
          )}
          {!fieldData.repeat && (
            <FormInputText
              fieldData={localFieldData}
              fieldInput={fieldInput}
              userInputHandler={userInputHandler}
            />
          )}
          {fieldData.desc_pos !== '1' && this.renderDescription()}
          {!isValid && (
            <div className="validation-error">
              {validationMessage}
            </div>
          )}
        </div>
      );
    }
    const classNames = active === '1' ? 'field-accept' : 'field-accept hidden-field';
    return (
      <div className={classNames}>
        <FormInputCheckbox
          fieldData={localFieldData}
          fieldInput={fieldInput}
          userInputHandler={userInputHandler}
        />
        {!isValid && (
          <div className="validation-error">
            {validationMessage}
          </div>
        )}
      </div>
    );
  }
}

FormField.propTypes = {
  fieldData: formSchemaPropType.isRequired,
  fieldInput: PropTypes.string.isRequired,
  userInputHandler: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  validationMessage: PropTypes.string,
};

FormField.defaultProps = {
  validationMessage: '',
};
